package org.matthewo

import org.matthewo.pages.GameRecordsTable
import org.matthewo.pages.GameTeamsPeriodsScatterPlot
import org.matthewo.pages.Search
import org.matthewo.pages.admin.adminRoutes
import org.matthewo.pages.event.eventRoutes
import org.matthewo.pages.team.teamRoutes
import org.matthewo.router.TSRouter
import org.matthewo.router.div
import react.FC
import tanstack.react.router.RouterProvider
import tanstack.router.core.ParamName
import tanstack.router.core.RoutePath

val YEAR_PARAM = ParamName("year")

const val MATCH_SEARCH = "match"
const val TEAM_SEARCH = "team"
const val GAME_SPECIFIC_SEARCH = "gameSpecific"

val SEARCH_PATH = RoutePath("/search")
val TABLE_PATH = RoutePath(YEAR_PARAM / "table")
val GRAPH_PATH = RoutePath(YEAR_PARAM / "graph")

val appRouter = TSRouter(Root) {
    TSRedirect(RoutePath("/$"), SEARCH_PATH)

    TSRoute(SEARCH_PATH, Search)
    TSRoute(TABLE_PATH, GameRecordsTable)
    TSRoute(GRAPH_PATH, GameTeamsPeriodsScatterPlot)

    eventRoutes()
    teamRoutes()
    adminRoutes()
}

val Router = FC("Router") {
    RouterProvider { router = appRouter }
}
